import { render, staticRenderFns } from "./base-container.vue?vue&type=template&id=791c1927&scoped=true&"
import script from "./base-container.vue?vue&type=script&lang=js&"
export * from "./base-container.vue?vue&type=script&lang=js&"
import style0 from "./base-container.vue?vue&type=style&index=0&id=791c1927&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c1927",
  null
  
)

export default component.exports